var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLogoCloud = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 144,
  height: 144,
  fill: "none",
  viewBox: "0 0 144 144"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 144,
  height: 144,
  fill: "#0077FF",
  rx: 36
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "white",
  fillRule: "evenodd",
  d: "M67 43a21 21 0 0 0-21 24l1 6h-6a14 14 0 0 0 0 28h57a19 19 0 1 0-3-37l-6 1-1-5c-2-10-10-17-21-17Zm32 70H40a26 26 0 0 1-6-50 33 33 0 0 1 64-11 30 30 0 0 1 1 61Z",
  clipRule: "evenodd"
})));
export { SvgLogoCloud as ReactComponent };